import { signal } from '@preact/signals';

export const sidebarOpen = signal(false);
export const modalState = signal({ isOpen: false, content: null, title: '' });
// Why: Track current path as a signal so Sidebar re-renders on navigation
export const currentPath = signal(typeof window !== 'undefined' ? window.location.pathname : '/');

export function updateCurrentPath() {
  currentPath.value = window.location.pathname;
}

export function toggleSidebar() {
  sidebarOpen.value = !sidebarOpen.value;
}

export function openModal(title, content) {
  modalState.value = { isOpen: true, content, title };
}

export function closeModal() {
  modalState.value = { isOpen: false, content: null, title: '' };
}
